export default defineNuxtPlugin(nuxtApp => {
  const store = useMainStore()
  const showMessage = ({ content, status } : { content: string, status: string }) => {
    store.setMessage({ content, status} as Message)
  }
  return {
    provide: { showMessage }
  }
})
